import React, { useMemo } from 'react';
import './Page.css';
import { useTranslation } from 'react-i18next';

function Categories({ onBack, onPlay, levelsData, userLang }) {
  const { t } = useTranslation();

  const sampleCategories = useMemo(() => {
    const samples = {
      pt: ['Filmes', 'Séries', 'Música', 'Esportes', 'Comida', 'Tecnologia', 'Países', 'Animais', 'Jogos', 'Marcas'],
      en: ['Movies', 'TV Shows', 'Music', 'Sports', 'Food', 'Technology', 'Countries', 'Animals', 'Games', 'Brands'],
      es: ['Películas', 'Series', 'Música', 'Deportes', 'Comida', 'Tecnología', 'Países', 'Animales', 'Juegos', 'Marcas'],
    };
    return samples[userLang] || samples.en;
  }, [userLang]);

  const categories = useMemo(() => {
    if (!levelsData) return [];
    const map = new Map();
    for (const [levelKey, level] of Object.entries(levelsData)) {
      if (!levelKey.startsWith('level_')) continue;
      const theme = level?.themes?.[userLang];
      if (!theme) continue;
      const normalized = String(theme).trim();
      if (!normalized) continue;
      map.set(normalized, (map.get(normalized) || 0) + 1);
    }
    return Array.from(map.entries())
      .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
      .map(([name, count]) => ({ name, count }));
  }, [levelsData, userLang]);

  return (
    <div className="page-container">
      <h1>{t('categories_title')}</h1>
      <p>{t('categories_intro')}</p>

      {categories.length === 0 ? (
        <>
          <p>{t('categories_loading')}</p>
          <div className="page-card" style={{ marginTop: 12 }}>
            <h2 className="page-card-title">{t('categories_examples_title')}</h2>
            <p className="page-card-excerpt">{t('categories_examples_intro')}</p>
            <ul>
              {sampleCategories.map((c) => (
                <li key={c}>
                  <strong>{c}</strong>
                </li>
              ))}
            </ul>
          </div>
        </>
      ) : (
        <ul>
          {categories.map((c) => (
            <li key={c.name}>
              <strong>{c.name}</strong> — {t('categories_level_count', { count: c.count })}
            </li>
          ))}
        </ul>
      )}

      <div className="page-actions-row">
        <button className="back-button" onClick={onBack}>{t('back_to_home')}</button>
        <button className="back-button" onClick={onPlay}>{t('play_button')}</button>
      </div>
    </div>
  );
}

export default Categories;
